import CloseIcon from "../../assets/icons/CloseIcon";
import PenIcon from "../../assets/icons/PenIcon";
import LoadingSpinner from "../LoadingSpinner";
import styles from "./styles.module.css";

interface UploadSignatureProps {
  onClickCard: () => void;
  label: string;
  width: string;
  imageUrl: string;
  show: boolean;
  uploading: boolean;
  required: boolean;
  disabled: boolean;
  handleRemoveFile: (url: string) => void;
}
const UploadSignatureCard: React.FC<Partial<UploadSignatureProps>> = ({
  onClickCard,
  label,
  width,
  imageUrl,
  show,
  uploading,
  required,
  disabled,
  handleRemoveFile,
}) => {
  if (!show) return <></>;
  if (uploading) return <LoadingSpinner isRed />;
  return (
    <>
      {imageUrl ? (
        <div className={`${styles.imageWrapper} position-relative border`}>
          <img
            src={imageUrl}
            alt="signature"
            className={styles.signatureImage}
          />
          <button
            className="position-absolute top-0 end-0 bg-transparent border border-0"
            onClick={() => handleRemoveFile("")}
          >
            <CloseIcon fill="red" />
          </button>
        </div>
      ) : (
        <div
          className={`${width || "w-100"} ${disabled ? "pe-none" : ""}  d-flex flex-column  cursor-pointer`}
          onClick={onClickCard && onClickCard}
        >
          {label && (
            <span className={styles.uploadLabel}>
              {label} {required && <strong className="text-danger">*</strong>}
            </span>
          )}
          <div
            className={`${styles.uploadCardWrapper} d-flex align-items-center p-2 rounded dashedBorder justify-content-between`}
          >
            <small>
              Draw an <br /> e-signature
            </small>
            <button className="bg-transparent border border-0" type="button">
              <PenIcon />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default UploadSignatureCard;
